import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../Components/Header';
import ConnectModal from "../Connect Wallet/ConnectModal";
import SetPassword from "../Connect Wallet/SetPassword";
import axios from 'axios';
import { toast } from 'react-toastify';
import DynamicHeader from '../Header/DynamicHeader';

const Home = () => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const { data } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleWalletClick = async () => {
    const token = localStorage.getItem("token");
    if (!token) return navigate("/connect-wal");
    if (localStorage.getItem("passwordVerified") === "true") return navigate("/Lookna-wallet");
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await Promise.all([
        axios.get("https://looknatest.com/wallet/wallet/getAssetsByChain?chainId=1", { headers }),
        axios.get("https://looknatest.com/wallet/wallet/getPublicKeyEvmGenerated", { headers }),
      ]);
      setIsConnectModalOpen(true);
    } catch (err) {
      if (err?.response?.status === 403) {
        navigate("/connect-wal");
      } else {
        toast.error("Unable to access wallet. Please try again.");
      }
    }
  };

  // Button data for mapping
  const buttons = [
    { code: "CEX", label: "CENTRALIZED EXCHANGE", path: "/CEX", highlight: true },
    { code: "DEX", label: "DECENTRALIZED EXCHANGE", path: "/DEX" },
    { code: "PS", label: "PRIVATE SALE", path: "/private-sale" },
    { code: "STI", label: "Scam Token Identifier", path: "/check-scam" },
    { code: "FAV", label: "My Watch List", path: "/watch-list" }
  ];

  return (
    <div className='home-background'>
      {/* Sticky Header */}
      <div className='home-header-sticky'>
        {/* <Header showHeader={true} /> */}
        <DynamicHeader/>
      </div>
      <div className='home-index'>
        <div className="home-card">
          <div className="home-btn-list">
            {/* Main 5 buttons */}
            {buttons.map(btn => (
              <div key={btn.code} className="home-btn-wrap">
                <Link to={btn.path} className={`home-btn${btn.highlight ? ' home-btn-highlight' : ''}`}>
                  <span className="home-btn-code">{btn.code}</span>
                  <span className="home-btn-label">{btn.label}</span>
                  <span className="home-btn-arrow">{'>'}</span>
                </Link>
              </div>
            ))}
            {/* Wallet Button: with click handler */}
            <div className="home-btn-wrap" onClick={handleWalletClick}>
              <button className="home-btn" style={{ width: '100%' }}>
                <span className="home-btn-code">WAL</span>
                <span className="home-btn-label">Wallet</span>
                <span className="home-btn-arrow">{'>'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isConnectModalOpen && (
        data?.WalletStatus === true
          ? <ConnectModal onClose={() => setIsConnectModalOpen(false)} />
          : <SetPassword onClose={() => setIsConnectModalOpen(false)} />
      )}
    </div>
  );
};

export default Home;
